import { GenIcon } from 'react-icons';
export const MdCurrencyFlagCzk = GenIcon({
    tag: 'svg',
    attr: {
        viewBox: '0 0 24 24',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
    },
    child: [
        {
            tag: 'g',
            attr: { clipPath: 'url(#clip0_21686_27939)' },
            child: [
                {
                    tag: 'rect',
                    attr: {
                        width: '24',
                        height: '24',
                        fill: '#FFFFFF',
                    },
                    child: [],
                },
                {
                    tag: 'rect',
                    attr: {
                        y: '12.5',
                        width: '24',
                        height: '12',
                        fill: '#FF3737',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M-3.03731 -2.15025L11.6116 12.4987L-5.35896 29.4692L-3.03731 -2.15025Z',
                        fill: '#006BAB',
                    },
                    child: [],
                },
                {
                    tag: 'circle',
                    attr: {
                        cx: '12',
                        cy: '12',
                        r: '11.5',
                        stroke: 'white',
                    },
                    child: [],
                },
            ],
        },
        {
            tag: 'defs',
            attr: {},
            child: [
                {
                    tag: 'clipPath',
                    attr: { id: 'clip0_21686_27939' },
                    child: [
                        {
                            tag: 'rect',
                            attr: {
                                width: '24',
                                height: '24',
                                rx: '12',
                                fill: 'white',
                            },
                            child: [],
                        },
                    ],
                },
            ],
        },
    ],
});
